// eslint-disable-next-line import/prefer-default-export
export const ADVERT_PROMO_CAMPAIGN_SET = 'ADVERT_PROMO_CAMPAIGN_SET';
